import React from 'react'
import { TextField } from '@mui/material';

export default function Input(props) {
    const { name, label, sx, value = "", error = null, onChange, disabled,required, ...rest } = props;
    return (
        <>
            <TextField
                variant="outlined"
                label={label}
                placeholder={
                    !label && required ? "Field is required *" : undefined
                }
                name={name}
                value={value}
                onChange={onChange}
                disabled={disabled}
                required={required}
                {...rest}
                fullWidth
                {...(error && { error: true, helperText: error })}
                sx={{
                    ...sx,
                    "& .MuiFormLabel-asterisk": {
                        color: "red",
                    },
                    "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
                        borderColor: "red !important",
                    },
                    "& .MuiFormHelperText-root.Mui-error": {
                        color: "red !important",
                    },
                }}
                InputLabelProps={{
                    sx: {
                        fontSize: "14px",
                        fontFamily: "Open Sans, sans-serif",
                        fontWeight: 400,
                        color: "#000000",
                    },
                    "& .MuiFormLabel-asterisk": {
                        color: "red",
                    },
                }}
                InputProps={{
                    sx: {
                        backgroundColor: `${ !value ? "#f0f0f0" : "#ffffff" }`,
                    }
                }}
            />

        </>
    )
}
